export const CDN_CONFIG = {
  audioBaseUrl: 'https://aen-reading-audio-1328906457.cos.ap-shanghai.myqcloud.com',
  useCDN: true,
};

export const getAudioUrl = (audioFileName) => {
  if (!audioFileName) return null;
  
  if (CDN_CONFIG.useCDN && CDN_CONFIG.audioBaseUrl) {
    return `${CDN_CONFIG.audioBaseUrl}/${audioFileName}`;
  }
  
  return `/audio/${audioFileName}`;
};
